import { render, staticRenderFns } from "./CreditScoringFarmName.vue?vue&type=template&id=71745d6b&scoped=true&"
import script from "./CreditScoringFarmName.vue?vue&type=script&lang=js&"
export * from "./CreditScoringFarmName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71745d6b",
  null
  
)

export default component.exports